export default "__VITE_ASSET__DBBIuLBm__"